'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _analytics = require('./analytics.component');

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsModule = _angular2.default.module('app.containers.analytics', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('analytics', {
    url: '/analytics',
    template: '<analytics></analytics>'
  });
}).component('analytics', _analytics2.default);

exports.default = analyticsModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics/analytics.js
 **/